import { gql } from "@apollo/client";

export const UP_CONNECT_DEVICE_SUBSCRIPTION = gql`
  subscription UP_CONNECT_DEVICE_SUBSCRIPTION($_eq: String = "") {
    Connect(where: {deviceId: {_eq: $_eq}}) {
      id
      deviceId
      deviceQueue:device_queue
      mobileQueue:mobile_queue
      updatedAtDeviceQueue:updated_at_device_queue
      updatedAtMobileQueue:updated_at_mobile_queue
      deviceQueueConnectionStatus:device_queue_connection_status
      mobileQueueConnectionStatus:mobile_queue_connection_status
    }
}`;